import { render } from "./shopDialog.vue?vue&type=template&id=6f41708d&scoped=true"
import script from "./shopDialog.vue?vue&type=script&lang=js"
export * from "./shopDialog.vue?vue&type=script&lang=js"

import "./shopDialog.vue?vue&type=style&index=0&id=6f41708d&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f41708d"]])

export default __exports__